/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */
 import config from '@/config';
 import OS_SaveContent from '@/services/paper/outline/saveContent';
 import PS_DownloadDocumentVersionV4 from '@/services/paper/downloadDocumentVersionV4';
 import PS_SaveDocument from '@/services/paper/saveDocument';
 import router from '@/router';

(function () {
	CKEDITOR.plugins.add('printDocument', {
		// icons: 'print', // %REMOVE_LINE_CORE%
		hidpi: true,
		canUndo: false,
		init(editor) {
			editor.addCommand('printDocument', {
				// for when the user is focused inside a ckInstance
				exec() {
					if(router.currentRoute.meta.tab === config.enums.Tab.EDITOR){
						PS_SaveDocument({
							message: 'Saved - Print Document',
						}).then((response)=>{
							PS_DownloadDocumentVersionV4({
								contentType: config.enums.DownloadPaperContentType.PDF,
								isPrint: true,
								platform: 1, // just Online Papers here
							});
						});
					} else if(router.currentRoute.meta.tab === config.enums.Tab.OUTLINE){
						OS_SaveContent().then(()=>{
							CKEDITOR.plugins.preview.createPreview( editor, function( previewWindow ) {
								var nativePreviewWindow = previewWindow.$;
				
								if ( CKEDITOR.env.gecko ) {
									nativePreviewWindow.print();
								} else {
									nativePreviewWindow.document.execCommand( 'Print' );
								}
				
								nativePreviewWindow.close();
							} );
						});
					}
				}//e:exec
			});

			editor.ui.addButton && editor.ui.addButton('Print', {
				label: 'Preview / Print',
				command: 'printDocument',
			});

			editor.setKeystroke(CKEDITOR.CTRL + 80, 'printDocument'); //P
		}
	});
})();